import script from "./SocialLinks.vue?vue&type=script&setup=true&lang=js"
export * from "./SocialLinks.vue?vue&type=script&setup=true&lang=js"

import "./SocialLinks.vue?vue&type=style&index=0&id=1d64f1b2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d64f1b2"]])

export default __exports__